import { useEffect, useMemo } from "react"
import type { BidArtifact } from "@/lib/api"
import { useResponsesStore } from "@/stores/responses-store"

/** The bid's response documents, oldest first (the order they were set up). */
export function useBidArtifacts(bidId: string): { artifacts: BidArtifact[]; isLoading: boolean } {
  const allArtifacts = useResponsesStore((s) => s.artifacts)
  const isLoading = useResponsesStore((s) => s.isLoading)
  const fetchArtifacts = useResponsesStore((s) => s.fetchArtifacts)

  useEffect(() => {
    void fetchArtifacts(bidId)
  }, [bidId, fetchArtifacts])

  const artifacts = useMemo(
    () =>
      allArtifacts
        .filter((a) => a.bidId === bidId)
        .sort((a, b) => a.createdAt.localeCompare(b.createdAt)),
    [allArtifacts, bidId]
  )
  return { artifacts, isLoading }
}
